
export interface TransferOfChargeSearchCriteria {

    chargeType: string | null,
    subChargeType: string | null,
    opsLine: string | null,
    opsDateFrom: Date | null,
    opsDateTo: Date | null,
    co: string | null,
    vsl: string | null,
    voy: string | null,
    cntrNos: string[] | null,
    billToCompany: string | null,
    chargeOnCompany: string | null,
    blNo1: string | null,
    soNumber1: string | null,
    agentCode: string | null,
    dtlState: string | null,
    serviceReferenceNo: string | null,
    serviceRequestCode: string | null,
    subServiceRequestCode: string | null,


    [key: string]: string | string[] | number | Date | null | undefined
}

export const EMPTY_TRANSFER_OF_CHARGE_SEARCH_CRITERIA: TransferOfChargeSearchCriteria = {
    chargeType: null,
    subChargeType: null,
    opsLine: null,
    opsDateFrom: null,
    opsDateTo: null,
    co: null,
    vsl: null,
    voy: null,
    cntrNos: [],
    billToCompany: null,
    chargeOnCompany: null,
    blNo1: null,
    soNumber1: null,
    agentCode: null,
    dtlState: null,
    serviceReferenceNo: null,
    serviceRequestCode: null,
    subServiceRequestCode: null
}